import React from "react";
import pic from "../../assets/images/discuss.png"
import "../../styles/forum.css";
import {Button} from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export default function InputBox() {

    const handleSubmit =()=>{

    }
  return (
    <>
      <div className="inputbox">
        <div className="box_left">
          <h1 className="header">Add Queries</h1>

          <input
            type="text"
            name=""
            className="question"
            placeholder="Enter your query..."
          />

          <textarea
            name="feedback"
            id=""
            cols="30"
            rows="10"
            placeholder="Describe in detail..."
            className="input2"
          ></textarea>
          
          <div className="btn">
            <Button
              type="submit"
              className="submit_btn"
              variant="contained"
              onClick={handleSubmit}
            >
              SUBMIT
              <FontAwesomeIcon icon="fa-solid fa-paper-plane" />
            </Button>
          </div>
        </div>

        <div className="box_right">
          <img src={pic} alt="forum pic" />
        </div>
      </div>
    </>
  );
}
